module.exports = __webpack_public_path__ + "static/media/img_factory_two.6bd95f09.jpg";